import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-31" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="1mb3xextzeule">
        <h2 className="font-heading text-lg font-extrabold uppercase leading-tight text-petrol sm:text-2xl" data-id="element-33" data-mp="1r3ncy0c8bzsu">
          This isn’t just another caregiving ebook
        </h2>
        <p className="mt-1 font-heading text-sm font-bold uppercase text-sage sm:text-base" data-id="element-34" data-mp="zd0ncfjtxo7k">
          It’s a complete ready-to-use organization system.
        </p>
        <div className="mt-4 grid grid-cols-1 gap-2.5 text-left sm:grid-cols-2" data-id="element-35" data-mp="13em6gimyiyq7">
          {differentiators.map(item => <div key={item.title} className="flex gap-2.5 rounded-xl bg-white p-3 shadow-sm" data-id="element-36" data-mp="1dciirdrmrzpw">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-37" data-mp="2jrj5qtyoh7kc">
                {item.emoji}
              </span>
              <div data-id="element-38" data-mp="2oq48p15be5ch">
                <h3 className="font-heading text-sm font-bold text-petrol sm:text-base" data-id="element-39" data-mp="2oti943uf44ha">
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.82rem] leading-snug sm:text-sm" data-id="element-40" data-mp="7mz4inyi49nv">
                  {item.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}